import MVT from 'ol/format/MVT.js';
import VectorTileLayer from "ol/layer/VectorTile";
import VectorTileSource from 'ol/source/VectorTile';
import { fromLonLat } from 'ol/proj';

export function transformPointsStructureFromWGS(structure) {
    if (typeof (structure) !== "object") {
        return null
    }
    if ((structure.length === 2) && (typeof (structure[0]) === "number") && (typeof (structure[1]) === "number")) {
        return fromLonLat(structure);
    }
    else {
        let newStructure = [];
        structure.forEach((item) => {
            let newItem = transformPointsStructureFromWGS(item);
            if (newItem) {
                newStructure.push(newItem);
            }
        });
        return newStructure;
    }
}

export function getMvtLayers() {

    let tilesArray = {
        vectorLayerRegions: {
            tilesUrl: "https://rk.geosamara.ru/mvtserver/RN_1_149/{z}/{x}/{y}.pbf",
            name: 'RN_1_149'
        },
        vectorLayerMunicipals: {
            tilesUrl: "https://rk.geosamara.ru/mvtserver/RN_1_150/{z}/{x}/{y}.pbf",
            name: 'RN_1_150'
        },
        vectorLayerSettlement: {
            tilesUrl: "https://rk.geosamara.ru/mvtserver/RN_1_151/{z}/{x}/{y}.pbf",
            name: 'RN_1_151'
        },
        vectorLayerCities: {
            tilesUrl: "https://rk.geosamara.ru/mvtserver/RN_1_152/{z}/{x}/{y}.pbf",
            name: 'RN_1_152'
        },
        vectorLayerLocalities: {
            tilesUrl: "https://rk.geosamara.ru/mvtserver/RN_1_153/{z}/{x}/{y}.pbf",
            name: 'RN_1_153'
        },
        vectorLayerStreets: {
            tilesUrl: "https://rk.geosamara.ru/mvtserver/RN_1_154/{z}/{x}/{y}.pbf",
            name: 'RN_1_154'
        },
        vectorLayerHouses: {
            tilesUrl: "https://rk.geosamara.ru/mvtserver/RN_1_141/{z}/{x}/{y}.pbf",
            name: 'RN_1_141'
        }
    }

    let vectorLayers = [];

    for (let layer in tilesArray) {
        const vector = new VectorTileLayer({
            declutter: true,
            source: new VectorTileSource({
                format: new MVT(),
                url: tilesArray[layer].tilesUrl
            })
        });
        vector.set('name', tilesArray[layer].name);
        vectorLayers.push(vector);
    }
    return vectorLayers;
}